import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import RequestForm from './components/RequestForm';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import StatusModal from './components/StatusModal';
import './App.css';

function App() {
    const [isAdmin, setIsAdmin] = useState(false);
    const [showAdmin, setShowAdmin] = useState(false);
    const [showStatus, setShowStatus] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('adminToken');
        if (token) {
            setIsAdmin(true);
            setShowAdmin(false);
        }
    }, []);

    const handleAdminLogin = (admin) => {
        setIsAdmin(true);
        setShowAdmin(false);
    };

    const handleAdminLogout = () => {
        setIsAdmin(false);
        setShowAdmin(false);
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUsername');
    };

    const toggleAdminView = () => {
        if (isAdmin) {
            setShowAdmin(!showAdmin);
        }
    };

    return (
        <div className="App">
            <Header />
            
            <div className="main-container">
                <div className="nav-bar">
                    <div className="nav-buttons">
                        <button 
                            className={`nav-btn ${!showAdmin && !showStatus ? 'active' : ''}`}
                            onClick={() => {
                                setShowAdmin(false);
                                setShowStatus(false);
                            }}
                        >
                            📝 Submit Request
                        </button>
                        <button 
                            className="nav-btn status-btn"
                            onClick={() => {
                                setShowStatus(true);
                                setShowAdmin(false);
                            }}
                        >
                            📋 Status
                        </button>
                        {isAdmin ? (
                            <button 
                                className={`nav-btn admin-btn ${showAdmin ? 'active' : ''}`}
                                onClick={toggleAdminView}
                            >
                                🔐 Admin Dashboard
                            </button>
                        ) : (
                            <button 
                                className="nav-btn admin-login-btn"
                                onClick={() => {
                                    setShowAdmin(true);
                                    setShowStatus(false);
                                }}
                            >
                                🔐 Admin Login
                            </button>
                        )}
                    </div>
                </div>

                <div className="content-area">
                    {showStatus ? (
                        <StatusModal onClose={() => setShowStatus(false)} />
                    ) : showAdmin ? (
                        isAdmin ? (
                            <AdminDashboard onLogout={handleAdminLogout} />
                        ) : (
                            <AdminLogin onLoginSuccess={handleAdminLogin} />
                        )
                    ) : (
                        <RequestForm />
                    )}
                </div>
            </div>

            <footer className="footer">
                <p>© 2026 Lufthansa Group — RosterX. All rights reserved.</p>
            </footer>
        </div>
    );
}

export default App;